module.exports = __webpack_public_path__ + "img/windows2.f12d2782.jpg";